import React from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { consultantHealthInsurerSingleUpdate } from '../../lib/redux/actions/consultantHealthInsurer';
import PropTypes from 'prop-types';
import { Cell } from 'react-sticky-table';
import { isSeniorStaff } from '../../lib/helper/authorisation';

const mapDispatchToProps = {
  consultantHealthInsurerSingleUpdate,
};

class EditableProviderNumberCell extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
      fieldValue: props.consultantHealthInsurer.providerReference,
    };
    this.handleChange = this.handleChange.bind(this);
    this.startEditing = this.startEditing.bind(this);
    this.stopEditing = this.stopEditing.bind(this);
    this.saveAndStopEditing = this.saveAndStopEditing.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.consultantHealthInsurer !== this.props.consultantHealthInsurer) {
      this.setState(() => ({
        fieldValue: this.props.consultantHealthInsurer.providerReference,
      }));
    }
  }

  handleChange(event) {
    this.setState(() => ({ fieldValue: event.target.value }));
  }

  startEditing() {
    if (!isSeniorStaff()) {
      return;
    }
    this.setState(() => ({ isEditing: true }));
  }

  stopEditing(e) {
    e.stopPropagation();
    this.setState(() => ({ isEditing: false }));
  }

  saveAndStopEditing(e) {
    if (!isSeniorStaff()) {
      return;
    }
    this.props.consultantHealthInsurerSingleUpdate({ providerReference: this.state.fieldValue }, this.props.consultantHealthInsurer.id);
    this.stopEditing(e);
  }

  render() {
    const { ccsdCode = { reference: '' }, consultantHealthInsurer } = this.props;

    return (
      <Cell title={`Edit ${ccsdCode.reference}`} onClick={this.startEditing} className="border-right text-center">
        {this.state.isEditing ? (
          <div className="input-group input-group--ccsdCode-inline-edit">
            <input
              autoFocus
              type="text"
              title="Consultant Provider Number"
              value={this.state.fieldValue}
              onChange={this.handleChange}
              className="form-control"
            />
            <div className="input-group-append">
              <Button variant="primary" size="sm" title="Save Provider Number Change" className="mb-0" onClick={this.saveAndStopEditing}>
                <i className="fas fa-check" />
              </Button>
              <Button variant="danger" size="sm" title="Cancel Provider Number Change" className="mb-0" onClick={this.stopEditing}>
                <i className="fas fa-times" />
              </Button>
            </div>
          </div>
        ) : (
          consultantHealthInsurer.providerReference
        )}
      </Cell>
    );
  }
}

EditableProviderNumberCell.propTypes = {
  consultantHealthInsurer: PropTypes.object.isRequired,
  ccsdCode: PropTypes.object,
  consultantHealthInsurerSingleUpdate: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(EditableProviderNumberCell);
